import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { ErrorResponse } from '@src/interface/api/response.interface'
import {
	GetRecentPromotionCodeRecordResBody,
	GetRecentPromotionCodeRecordQueryKey,
} from '@src/type/promotion'
import { getRecentPromotionCodeRecord } from '@src/lib/api/promotion'

export type ParamType = {
	queryKey: GetRecentPromotionCodeRecordQueryKey
}

export function useGetRecentPromotionCodeRecordQuery({ queryKey }: ParamType) {
	const useQueryResult = useQuery<
		GetRecentPromotionCodeRecordResBody,
		AxiosError<ErrorResponse>,
		GetRecentPromotionCodeRecordResBody,
		GetRecentPromotionCodeRecordQueryKey
	>(queryKey, async ({ queryKey: [_key, vendorNo] }) => {
		if (vendorNo === undefined) {
			return { data: { recent_record: null }, success: 1 }
		}

		const resBody = await getRecentPromotionCodeRecord()

		return resBody
	})

	return useQueryResult
}
